import { render, staticRenderFns } from "./CosmoClawTextOverlay.vue?vue&type=template&id=3b035fd4&scoped=true"
import script from "./CosmoClawTextOverlay.vue?vue&type=script&lang=js"
export * from "./CosmoClawTextOverlay.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawTextOverlay.vue?vue&type=style&index=0&id=3b035fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b035fd4",
  null
  
)

export default component.exports